/* eslint-disable @next/next/no-img-element */
/* eslint-disable react/no-unescaped-entities */
// @ts-nocheck
import { CardCreator, MetaData, StyledButton } from '@/components/atoms'
import route_list from '@/constant/routeUrl'
import { useRouter } from 'next/router'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { useTranslation } from 'next-i18next'
import Image from 'next/image'
import { background_list, icon_list } from '@/assets/images'
import { useRef, useEffect } from 'react'
import { TematicStudioBox, TitlePointDescSection, TitleWantToBeCreator } from '@/components/molecules'
import { getSeoMetadata } from '@/utility/apiProcess/seo/server'

const ContentCreator = (props) => {
	const { t } = useTranslation('creator')
	const router = useRouter()
 
  const howAreWeData = {
    title: t('creator.wbc'),
    description: t('creator.wbc_desc'),
    points: [
      {
        title: t('creator.wbc1'),
        description: t('creator.wbc1_desc')
      },
      {
        title: t('creator.wbc2'),
        description: t('creator.wbc2_desc')
      },
      {
        title: t('creator.wbc3'),
        description: t('creator.wbc3_desc')
      },
      {
        title: t('creator.wbc4'),
        description: t('creator.wbc4_desc')
      },
    ]
  }

  const whyYouShould = {
    title: t('creator.why'),
    description: t('creator.why_desc'),
    points: [
      {
        title: t('creator.w1'),
        description: t('creator.w1_desc')
      },
      {
        title: t('creator.w2'),
        description:t('creator.w2_desc')
      },
      {
        title: t('creator.w3'),
        description:t('creator.w3_desc')
      },
      {
        title: t('creator.w4'),
        description: t('creator.w4_desc')
      },
    ]
  }

  const dataCreator =  [
    {
      name: t('creator.pc1_name'),
      description: t('creator.pc1_desc'),
      image: background_list.cc1
    },
    {
      name: t('creator.pc2_name'),
      description: t('creator.pc2_desc'),
      image: background_list.cc2
    },
    {
      name: t('creator.pc3_name'),
      description: t('creator.pc3_desc'),
      image: background_list.cc3
    },
  ]
      
	return (
		<div className='tw-bg-gradient-to-r tw-from-dark-green tw-to-light-green tw-w-full'>
      <MetaData title={props.seoMetadata.title} ogImage="https://i.ibb.co/bzC5z1g/socialbreadlogo.jpg" ogTitle={props.seoMetadata.title} keywords={props.seoMetadata.keywords} ogDescription={props.seoMetadata.description} />
			<div className='tw-newsroom-banner' id='newsroom-banner'>
				<div className='tw-m-auto md:tw-py-16 tw-py-8 md:tw-px-0 tw-px-4 tw-max-w-6xl tw-mx-auto tw-grid md:tw-grid-cols-2 tw-gap-2'>
					<div className='tw-flex tw-flex-col tw-justify-center'>
            <h2 className='tw-text-white md:tw-text-5xl tw-text-2xl tw-font-semibold tw-mb-5 md:tw-text-left tw-text-center'>
              {t('creator.title')}
            </h2>
            <span className='tw-text-white tw-text-sm md:tw-text-justify tw-flex tw-text-center'>
              {t('creator.desc')}
            </span>
            <div className='md:tw-flex tw-hidden tw-items-end tw-flex-row tw-gap-2 tw-mt-5'>
              <StyledButton
                title={t('creator.apply')}
                className='tw-text-white tw-mt-5 tw-font-semibold md:tw-text-xl tw-text-xs tw-items-center tw-border-2 tw-border-white md:tw-px-6 tw-px-5 md:tw-py-2 tw-py-3 tw-rounded-full tw-justify-center md:tw-flex'
                onClick={() => {
                  window.fbq('track', 'Apply now', {content_name: router.route})
                  router.push(`${route_list.register}?type=partner`)
                }}
              />
            </div>
          </div>
          <div className='tw:w-full tw-flex tw-flex-col tw-items-center tw-justify-center'>
            <Image src={background_list.content_creator} alt='' className='md:tw-w-[60%] tw-w-[50%]' />
            <div className='md:tw-hidden tw-flex tw-items-end tw-flex-row tw-gap-2 tw-mt-5'>
              <StyledButton
                title={t('creator.apply')}
                className='tw-text-white tw-mt-5 tw-font-semibold md:tw-text-xl tw-text-xs tw-items-center tw-border-2 tw-border-white md:tw-px-6 tw-px-5 md:tw-py-2 tw-py-3 tw-rounded-full tw-justify-center md:tw-flex'
                onClick={() => {
                  window.fbq('track', 'Apply now', {content_name: router.route})
                  router.push(`${route_list.register}?type=partner`)
                }}
              />
            </div>
          </div>
				</div>
			</div> 
			<div className='tw-w-full tw-min-h-[500px] tw-flex tw-items-center tw-justify-center tw-flex-col tw-bg-[#F1F1F1] md:tw-rounded-[40px] tw-rounded-[20px] tw-overflow-hidden'>
				<div className='tw-newsroom-container'>
					<div className='tw-max-w-6xl tw-mx-auto tw-my-8 md:tw-px-0 tw-px-4 tw-text-justify'>
            {/* Social bread content creator */}
            <div className="tw-w-full md:tw-mb-0 tw-rounded-xl">
              <div className=' tw-bg-white tw-p-4 tw-rounded-xl tw-h-full tw-flex tw-flex-col tw-items-center'>
                <h2 className="md:tw-text-4xl tw-text-2xl tw-text-center tw-font-semibold tw-text-transparent tw-bg-clip-text tw-bg-gradient-to-r tw-from-dark-green tw-to-light-green tw-mb-3 tw-w-fit">
                  {t('creator.sbc')}
                </h2>
                <div className="tw-text-base tw-leading-7 tw-black tw-text-center">
                  {t('creator.sbc_desc')}
                </div>
              </div>
            </div>
            {/* Why you should join us? */}
            <div className='tw-my-20'>
              <TitlePointDescSection data={whyYouShould}/>
            </div>
            
            {/* Our Creators */}
            <div className='tw-my-20'>
              <div className='tw-mb-10'>
                <h1 className='md:tw-text-5xl tw-text-2xl tw-font-semibold tw-mb-3 tw-text-transparent tw-bg-clip-text tw-bg-gradient-to-r tw-from-dark-green tw-from-30% tw-to-light-green tw-to-70% tw-text-left tw-w-fit'>{t('creator.oc')}</h1>
                <span>{t('creator.oc_desc')}</span>
              </div>
              <div className=' tw-flex tw-items-center tw-justify-center'>
                <h1 className='md:tw-text-2xl tw-text-2xl tw-font-semibold tw-mb-3 tw-text-transparent tw-bg-clip-text tw-bg-gradient-to-r tw-from-dark-green tw-from-40% tw-to-light-green tw-to-90% tw-text-left tw-w-fit'>{t('creator.pc')}</h1>
              </div>
              <CardCreator data={dataCreator} images={[background_list.gradient_blue, background_list.gradient_blue_reverse]}/>
            </div>

            {/* Want to be a Content Creator? */}
            <div className='tw-my-16'>
              <TitleWantToBeCreator data={howAreWeData}/>
            </div>

            <div className='tw-flex tw-justify-center tw-mb-32'>
              <StyledButton
                title={t('creator.apply')}
                className='tw-text-white tw-font-semibold btn-dark-to-light-green-gradient md:tw-text-lg tw-text-xs tw-items-center md:tw-px-14 tw-px-10 md:tw-py-2 tw-py-3 tw-rounded-full tw-justify-center md:tw-flex'
                onClick={() => {
                  window.fbq('track', 'Apply now', {content_name: router.route})
                  router.push(`${route_list.register}?type=partner`)
                }}
              />
            </div>
        
					</div>
				</div>
			</div>
		</div>
	)
}

export default ContentCreator

export async function getStaticProps() {
  const locale = 'id'
  let seoMetadata = { data: { result: {} } }
  try {
    seoMetadata = await getSeoMetadata({category_slug: 'pages', names: 'endorsement'})
  } catch (err) {
    console.error('[getStaticProps] getSeoMetadata failed at build time, falling back to {}', err)
  }

  return {
		props: {
      seoMetadata: seoMetadata.data.result || {},
			...(await serverSideTranslations(locale, ['footer', 'navbar', 'privacy-policy'])),
		},
	}
}
